import ProductService from "app/services/productService";
import UserService from "app/services/userService";
import ProductCard from "components/ProductCard";
import { Product } from "data/data";
import { useEffect, useState } from "react";
import Dash from "..";

interface StatProp {
  label: String;
  value: Number;
  icon?: any;
  color?: String;
  border?: String;
}

const Statistic = ({ label, value, icon, color, border }: StatProp) => {
  return (
    <div className="w-full lg:w-1/4 md:w-1/2">
      <div
        className={`widget w-full p-4 rounded-lg bg-gray-100 ${border} border-l-4 `}
      >
        <div className="flex items-center">
          <div
            className={`icon w-14 p-3.5 ${color} text-white rounded-full mr-3`}
          >
            {icon}
          </div>
          <div className="flex flex-col justify-center">
            <div className="text-lg">{`${value}`}</div>
            <div className="text-sm text-gray-400">{label}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
const AccountProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [nbBoost, setNbBoost] = useState<Number>(0);
  const [nbProdect, setNbProdect] = useState<Number>(0);
  const [nbProdectR, setNbProdectR] = useState<Number>(0);

  useEffect(() => {
    ProductService.getUserProduct().then((data) => {
      setProducts(data);
    });
    UserService.get().then((data) => {
      console.log(data);
      setNbBoost(data.boost);
      setNbProdect(data.number_of_product);
      setNbProdectR(data.number_of_product - data.products_count);
    });
  }, []);
  const renderSection1 = () => {
    return (
      <div className="space-y-10 sm:space-y-12 p-10">
        {/* <div className="flex flex-col lg:flex-row w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4  md:flex-row md:space-x-2 md:space-y-0 md:mb-4">
        <Statistic 
          label='boost' 
          value={nbBoost}
          icon={ <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
          </svg>}
          color={'bg-green-400'}
          border={'border-green-400'}
         />
        <Statistic 
          label='produits' 
          value={nbProdect}
          icon={ <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
          </svg>}
          color={'bg-yellow-400'}
          border={'border-yellow-400'}
           />
           <Statistic 
          label='produits restent' 
          value={nbProdectR}
          color={'bg-blue-400'}
          border={'border-blue-400'}
          icon={ <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
          </svg>}
          
           />
        </div> */}

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ">
          {products
            .filter((_, i) => i < 6)
            .map((stay) => (
              <ProductCard key={stay.id} mode="user" data={stay} />
            ))}
        </div>
      </div>
    );
  };

  return <Dash>{renderSection1()}</Dash>;
};

export default AccountProducts;
